import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const StepsMeta: ComponentMeta = {
  componentName: "Steps",
  package: "@mijadesign/web",
  title: "步骤条",
  description: "引导用户按照步骤完成任务的分步导航",
  category: ComponentCategory.NAVIGATION,
  icon: "OrderedListOutlined",
  canHaveChildren: true,
  acceptedChildren: ["Steps.Step"],
  props: [
    {
      name: "current",
      label: "当前步骤",
      type: PropType.NUMBER,
      defaultValue: 0,
      group: "状态",
    },
    {
      name: "status",
      label: "当前状态",
      type: PropType.ENUM,
      defaultValue: "process",
      options: [
        { label: "等待", value: "wait" },
        { label: "进行中", value: "process" },
        { label: "完成", value: "finish" },
        { label: "错误", value: "error" },
      ],
      group: "状态",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "默认", value: "default" },
        { label: "小", value: "small" },
      ],
      group: "展示",
    },
    {
      name: "direction",
      label: "方向",
      type: PropType.ENUM,
      defaultValue: "horizontal",
      options: [
        { label: "水平", value: "horizontal" },
        { label: "垂直", value: "vertical" },
      ],
      group: "布局",
    },
    {
      name: "labelPlacement",
      label: "标签位置",
      type: PropType.ENUM,
      defaultValue: "horizontal",
      options: [
        { label: "水平", value: "horizontal" },
        { label: "垂直", value: "vertical" },
      ],
      group: "布局",
    },
    {
      name: "percent",
      label: "当前步骤进度",
      type: PropType.NUMBER,
      description: "在 Steps.Step 中设置，表示当前步骤的进度百分比",
      group: "状态",
    },
  ],
  defaultProps: {
    current: 0,
    status: "process",
    direction: "horizontal",
    labelPlacement: "horizontal",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Steps",
  },
  snippet: {
    componentName: "Steps",
    package: "@mijadesign/web",
    props: { current: 0 },
  },
};

export const StepMeta: ComponentMeta = {
  componentName: "Steps.Step",
  package: "antd",
  title: "步骤",
  description: "步骤条的子组件，定义单个步骤",
  category: ComponentCategory.NAVIGATION,
  icon: "CheckCircleOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "title",
      label: "标题",
      type: PropType.STRING,
      defaultValue: "步骤",
      group: "内容",
    },
    {
      name: "subTitle",
      label: "子标题",
      type: PropType.STRING,
      group: "内容",
    },
    {
      name: "description",
      label: "描述",
      type: PropType.STRING,
      group: "内容",
    },
    {
      name: "status",
      label: "状态",
      type: PropType.ENUM,
      defaultValue: "wait",
      options: [
        { label: "等待", value: "wait" },
        { label: "进行中", value: "process" },
        { label: "完成", value: "finish" },
        { label: "错误", value: "error" },
      ],
      group: "状态",
    },
    {
      name: "icon",
      label: "图标",
      type: PropType.STRING,
      group: "图标",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
  ],
  defaultProps: {
    title: "步骤",
  },
  npm: {
    package: "antd",
    exportName: "Steps",
  },
  snippet: {
    componentName: "Steps.Step",
    package: "antd",
    props: { title: "步骤" },
  },
};
